import { apiClient } from "@/lib/api-client"
import { HttpStatusCodes } from "@/lib/http-status-codes"
import type {
  Careers24ConnectionDto,
  Careers24UpsertRequestDto,
  Careers24UpsertResponseDto,
} from "../dtos/Careers24ConnectDto"

export async function getConnection(
  organizationId: string | null,
): Promise<Careers24ConnectionDto | null> {
  try {
    const response = await apiClient.get<Careers24ConnectionDto>(
      `/organizations/${organizationId}/careers24/connection`,
    )
    return response.data
  } catch (err: unknown) {
    const status =
      typeof err === "object" && err !== null
        ? ((err as { response?: { status?: number } }).response?.status ?? 0)
        : 0
    if (status === HttpStatusCodes.NOT_FOUND) return null
    throw err
  }
}

export async function upsertConnection(
  organizationId: string | null,
  dto: Careers24UpsertRequestDto,
): Promise<Careers24UpsertResponseDto> {
  const response = await apiClient.post<Careers24UpsertResponseDto>(
    `/organizations/${organizationId}/careers24/connection`,
    dto,
  )
  return response.data
}

export async function deleteConnection(
  organizationId: string | null,
): Promise<void> {
  await apiClient.delete(
    `/organizations/${organizationId}/careers24/connection`,
  )
}

export const careers24ConnectorService = {
  getConnection,
  upsertConnection,
  deleteConnection,
}
